import { render, staticRenderFns } from "./NaverAdHeader.vue?vue&type=template&id=65a85fc0"
import script from "./NaverAdHeader.vue?vue&type=script&lang=js"
export * from "./NaverAdHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports